import { render, staticRenderFns } from "./sign-configuration.vue?vue&type=template&id=c2a30bf8&"
import script from "./sign-configuration.vue?vue&type=script&lang=ts&"
export * from "./sign-configuration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports